import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Guarantee } from "@/components/Guarantee";
import { Transformation } from "@/components/Transformation";
import { HowItHappens } from "@/components/HowItHappens";
import { HomeRespect } from "@/components/HomeRespect";
import { Services } from "@/components/Services";
import { Testimonials } from "@/components/Testimonials";
import { Manifesto } from "@/components/Manifesto";
import { QuoteForm } from "@/components/QuoteForm";
import { Footer } from "@/components/Footer";

const LINKS = [
  { label: "Transformations", target: "#transformations" },
  { label: "Services", target: "#services" },
  { label: "The Difference", target: "#difference" },
  { label: "Main site", to: "/" },
];

export default function OfferPage() {
  return (
    <div data-testid="offer-page">
      <Nav links={LINKS} cta={{ label: "Get a free quote", short: "Free quote", target: "#quote-form", testId: "nav-get-quote-btn" }} />
      <main>
        <Hero />
        <Marquee />
        <Guarantee />
        <Transformation />
        <HowItHappens />
        <HomeRespect />
        <Services />
        <Testimonials />
        <Manifesto />
        <QuoteForm />
      </main>
      <Footer />
    </div>
  );
}
